<!-- 因子分析 -->
<template>
    <div class="excavate-factor">
        <div class="factor-top">
            <p>因子分析是指研究从变量群中提取共性因子的统计技术。因子分析的主要目的是用来描述隐藏在一组测量到的变量中的一些更基本的，但又无法直接测量到的隐性变量。将相同本质的变量归入一个因子，可减少变量的数目，还可检验变量间关系的假设。</p>
            <p> <b>因子分析的步骤：</b> </p>
            <p>1.对数据进行标准化处理；</p>
            <p>2.判断数据是否适合适合因子分析 :一般通过KMO( Overall MSA检验统计量一般大于0.5大于0.9时非常适合因子分析)和Bartlette检验p值一般小于等于0.05 )，检验数据是否适合进行因子分析;</p>
            <p>3.选择因子个数：可以根据先验知识和理论知识判断；最常见的是基于特征值的方法：每个因子都与相关系数矩阵的特征值相关联，第一个因子与最大的特征值相关联，第二个因子与第二大的特征值相关联，以此类推，保留特征值大于1的因子。</p>
            <p>4.构造因子变量：提取公共因子一般使用主轴迭代法。</p>
            <p>5.因子旋转：利用旋转更好地对新的因子变量能够进行命名和解释，一般通过正交旋转使得因子之间不相关，重点在于说明因子和变量之间的相关系数。</p>
            <p> <b>结果解释：</b> </p>
            <p>PA栏表示各因子能够解释的各变量的特征百分率 H2栏表示公因子对每个变量的解释比例， u2栏表示方差无法被公因子解释的部分。</p>
            <p>SS loadings包含了与因子相关联的特征值，其含义是与特定因子相关联的标准化后的方差值，即可以通过它来看90%的方差可以被多少个因子解释，从而选出因子。</p>
            <p>Proportion&nbsp;Var表示每个因子对整个数据集的解释程度。</p>
            <p>Cumulative&nbsp;Var表示各因子解释程度之和。</p>
            <p>Proportion&nbsp;Explained及Cumulative&nbsp;Proportion分别为按现有总解释方差百分比划分因子及累积百分比。</p>
        </div>
        <div class="factor-search flex">
            <div class="search-left">
                <p class="procedure-num"><b>步骤1：</b></p>
                <el-form  class="search-form">
                    <el-form-item label="筛选前" :label-width="labelWidth">
                        <el-input class="search-num" :min="1" type='number' size='mini' v-model='topValue'></el-input>个进行因子分析
                    </el-form-item>
                    <el-form-item label="类型：" :label-width="labelWidth">
                        <el-radio-group v-removeAriaHidden v-model="searchType" >
                            <el-radio @change="changeRadin" v-for="(item,index) in searchRadio" :key="index" :label="item.label">{{item.value}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <div>
                <el-button type="primary" size="small" @click="factor_click">数据检验</el-button>
            </div>
        </div>
        <!-- 和K-means一样 -->
        <clusterTable ref="cluster_table" ></clusterTable>
        <div class="factor-search " v-show='procedureTwo' id="procedureTwo">
            <p class="procedure-num"><b>步骤2：</b></p>
            <p>KMO检验中Overall MSA值大于0.5，该值大于0.95时该数据非常适合进行因子分析; Bartlette检验中P.value值小于0.05时该数据适合进行因子分析。</p>
            <div class="inspect-info" v-html='inspectInfo'></div>
            <div class="pad-top20" id="procedureThree">
                <el-button type="primary" size="small" @click="download_TXT(2)">TXT下载</el-button>
                <el-button type="primary" size="small" :disabled='beginDisabled' @click="begin_click">开始分析</el-button>
            </div>
        </div>
        <div v-if='procedureThree'>
            <p class="procedure-num"><b>步骤3：确定因子个数 </b></p>
            <p>因子个数确定原则：①可测变量的方差协方差矩阵对应的特征方程的根(简称为特征根)大于1，参考本结果红线位置；②在整个曲线下降过程，选择具有明显弯折点，该店对应X轴的数字即应保留的因子个数。</p>
            <div class="factor-pic"  v-loading='imgLoad'>
                <el-image  
                    width="100%"
                    :src="imgUrl" 
                    ref="imgUrlUrl"
                    :preview-src-list="imgUrl_srcList">
                </el-image>
            </div>
            <div class="factor-search flex pad-top20" id="procedureFour">
                <div class="search-left">
                    <p class="procedure-num"><b>确定因子个数</b></p>
                    <el-form  class="search-form">
                        <el-form-item label="" label-width="10px">
                            <el-input class="search-num" :min="1" type='number' size='mini' v-model='PACount'></el-input> 
                        </el-form-item>
                        <el-button type="primary" size="small" @click="sure_data">获取结果</el-button>
                    </el-form>
                </div>
                <p class="pic-tip"><span class="tip">*图片可点击放大</span> </p>
            </div> 
        </div>
        <div v-if='procedureFour'>
            <p class="procedure-num"><b>步骤4：结果展示 </b></p>
            <p>因子个数确定原则：①可测变量的方差协方差矩阵对应的特征方程的根(简称为特征根)大于1，参考本结果红线位置；②在整个曲线下降过程，选择具有明显弯折点，该店对应X轴的数字即应保留的因子个数。</p>
            <div class="factor-pic" v-loading='resultLoad'>
                <el-image  
                    width="100%"
                    :src="resultUrl" 
                    ref="resultUrl"
                    :preview-src-list="resultUrl_srcList">
                </el-image>
            </div>
            <div>
                <el-button type="primary" size="small"  @click="report_clik">生成报告</el-button>
                <el-button type="primary" size="small" @click="download_TXT(4)">TXT下载</el-button>
            </div>
        </div>
         <!-- 生成报告 -->
        <reportModel  :ok="'确定'" :cancel="'取消'" :show.sync='isShowReport' :titleName='`${eTitle}-因子分析`' :reportList='k_table' :reportImg='reportImg'></reportModel>
    </div>
</template>

<script>
import { mapState,mapMutations, mapActions } from 'vuex';
import {getPinCi,yinZiFenXi,kmoJS_yz,yinZiFenXiZheXian_yz,exportTxt_yz} from '../../io/api.js'
import clusterTable from './K_Means/cluster_table.vue';
import reportModel from './comps/report_model.vue'
export default {
    components: {
        clusterTable,
        reportModel
    },
    data () {
        return {
            labelWidth:'60px', 
            PACount:'',
            topValue:'',
            kValue:'',
            searchType:'HERB',
            searchRadio:[
                {
                    value:'中药',
                    label:'HERB'
                },
                {
                    value:'症状',
                    label:'SYMP'
                },
                {
                    value:'穴位',
                    label:'XW'
                },
                {
                    value:'证侯',
                    label:'ZH'
                }
            ],
            tableList:[],
            procedureTwo:false,
            procedureThree:false,
            procedureFour:false,
            beginDisabled:false,
            resultLoad:false,
            imgLoad:false,
            kmoTxtName:'',//步骤er数据检验下载文件名称
            resultTxtName:'',//步骤四结果下载文件名称
            imgUrl:'',//require('../../assets/images/1.png'),
            imgUrl_srcList:[],
            resultUrl:'',
            resultUrl_srcList:[],
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
            inspectInfo:'',
            tempKmo:[],
            isShowReport:false,
            eTitle:'',
            reportImg:'',
        }
    },
    computed: {
        ...mapState({
            // k_isLoad:state=>state.excavate.k_isLoad,
            k_table:state=>state.excavate.k_table, 
        })
    },
    mounted () {
        this.getInfo()  
    },
    methods: { 
         ...mapMutations(['setKTable']),
        getInfo(){
            // table 同K-means一致
            getPinCi({type:this.searchType}).then((res)=>{
                let data = res.data;
                if(data&&data.code==0){
                    this.setKTable(data.data)
                    // 清除排序
                    this.$refs.cluster_table.clearSort()
                    this.$refs.cluster_table.changePage(1)
                }else{
                    this.$message.error(data.msg||'请求失败～')
                }
            })
        },
        initSearch(){
            this.procedureTwo=false;
            this.procedureThree=false;
            this.procedureFour=false;
            this.imgUrl='';
            this.PACount='';
            this.imgUrl_srcList=[];
            this.resultUrl='',
            this.resultUrl_srcList=[],
            this.pageInfo={
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            };
        },
        //步骤一类型
        changeRadin(val){
            this.searchType = val; 
            this.initSearch()
            this.getInfo();
        }, 
        //数据检验
        factor_click(){ 
            this.initSearch()
            if(this.topValue==''){
                this.$message.error( '请筛选数据～')
                return
            }
            let params={
                topValue:this.topValue,
                type:this.searchType,
            }
            this.tempKmo=[];
            this.inspectInfo=''
            kmoJS_yz(params).then(res=>{
                let data = res.data;
                if(data&&data.code==0){
                    this.kmoTxtName=data.data.kmoTxt;
                    let txt =data.data.txt; 
                    let tempPValue = '';  
                    let flag = 0;
                    let msa;
                    let pValue;
                    txt&&txt.forEach(item => { 
                        if(item.search('Overall&nbspMSA') !== -1){
                            this.inspectInfo += "<p style='color: red'>" + 'KMO检验结果:'+ item + "</p>"
                            this.tempKmo.push('KMO检验:' + item); 
                            msa = item.split("=")[1].replaceAll("&nbsp",'') * 1;
                        }else if (item.search('p.value') !== -1){
                            tempPValue = 'Bartlette 检验结果:' + item; 
                            flag = 1;
                            this.tempKmo.push('Bartlette 检验:' + item) 
                        }
                        else if(flag == 1){
                            tempPValue = tempPValue + ' = ' + item.split("&nbsp")[1];
                            this.inspectInfo += "<p style='color: red'>" + tempPValue.replaceAll('$','') + "</p>"
                            flag = 0;
                            this.tempKmo.push(item); 
                            pValue = item.split("&nbsp")[1] * 1;
                        }
                    });  
                    if (Number(msa) < 0.5 || Number(pValue) > 0.05){
                       this.beginDisabled=true; 
                    } else{
                        this.beginDisabled=false 
                    }
                }else{
                    this.$message.error( data.msg||'请求错误～')
                }
            })
            this.procedureTwo = true;
            setTimeout(() => {
                this.getlocal('procedureTwo');
            }, 200);
            this.procedureThree =false;
        },
        //开始分析
        begin_click(){ 
            this.imgLoad = true;
            this.procedureThree=true;
            let params={
                topValue:this.topValue,
                type:this.searchType,
            }
            yinZiFenXiZheXian_yz(params).then(res=>{
                let data = res.data;
                if(data&&data.code==0){
                    this.imgUrl=data.data.plotImage; 
                    this.imgUrl_srcList=[].concat(this.imgUrl)
                    setTimeout(() => { 
                        this.getlocal('procedureThree')
                    }, 200);
                }else{
                    this.$message.error( data.msg||'请求错误～')
                }
                this.imgLoad = false;
            }) 
        },
        //获取结果
        sure_data(){
            if(this.PACount == ""){
                this.$message.error( '请输入因子个数～')
                return;
            }
            this.resultLoad=true;
            let params={
                PACount:this.PACount,
                topValue:this.topValue,
                type:this.searchType,
            }
            yinZiFenXi(params).then(res=>{
                let data = res.data;
                if(data&&data.code==0){
                    this.resultTxtName = data.data.txtName
                    this.resultUrl=data.data.faImage; 
                    this.resultUrl_srcList=[].concat(this.resultUrl);
                    this.procedureFour=true; 
                    setTimeout(() => { 
                        this.getlocal('procedureFour')
                    }, 200);
                }else{
                    this.$message.error( data.msg||'请求错误～')
                }
                this.resultLoad = false;
            })  
            // this.procedureThree=true;
        },
         //锚点定位
        getlocal(id) { 
			//找到锚点id  
			let toElement = document.getElementById(id); 
			//如果对应id存在，就跳转 
			if (id) {   
				toElement.scrollIntoView({ behavior: 'smooth' }); 
			} 
		}, 
        //txt下载
        download_TXT(type){
            let fileName;
            if(type==2){
                fileName=this.kmoTxtName
            }else if(type==4){
                fileName=this.resultTxtName
            }
            exportTxt_yz({fileName}).then(res=>{
                {
                    this.down_blob(`${fileName}`,res)
                    
                }
            })
        },
        down_blob(name,res){ 
            let typeCount = {
                type: "application/octet-stream",
            }; 
            let blob = new Blob([res.data],typeCount); 
                let url = window.URL.createObjectURL(blob);
                let link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", name);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                this.isDerive = false;
            // }
        },
        //生成报告
        report_clik(){ 
            this.isShowReport = true; 
            let eImg=this.imgUrl_srcList.concat(this.resultUrl_srcList);
            this.reportImg=JSON.stringify(eImg)
            this.searchRadio.forEach(item => {
                if(item.label==this.searchType){
                    this.eTitle = item.value
                }
            });
        },
    }
}
</script>
<style lang="less" scoped>
.factor-pic{
    width: 100%;
    margin: 10px 0 20px;
    min-height: 200px;
}
.pad-top20{
    padding-top: 20px;
}
</style>